import React from 'react'

const Guidance = () => {
  return (
    <div>Guidance</div>
  )
}

export default Guidance